(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('review-slider')) {
    class ReviewSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-reviews-track]');
        this.slides = this.track ? Array.from(this.track.querySelectorAll('[data-reviews-slide]')) : [];
        if (!this.track || this.slides.length === 0) return;

        this.dotsEl = this.querySelector('[data-reviews-dots]');
        this.prevBtn = this.querySelector('[data-reviews-prev]');
        this.nextBtn = this.querySelector('[data-reviews-next]');
        this.currentEl = this.querySelector('[data-reviews-current]');
        this.totalEl = this.querySelector('[data-reviews-total]');

        this.loop = this.dataset.loop === 'true';
        this.index = 0;
        this.ticking = false;
        this.dotCount = 0;

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);
        this.onVisibility = this.onVisibility.bind(this);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

        this.addEventListener('pointerenter', () => this.pause());
        this.addEventListener('pointerleave', () => this.play());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.play());
        document.addEventListener('visibilitychange', this.onVisibility);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this);
        } else {
          window.addEventListener('resize', this.onResize);
        }

        this.render();
        this.play();
      }

      disconnectedCallback() {
        this.pause();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      get reduceMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      get gap() {
        return parseFloat(getComputedStyle(this.track).columnGap) || 0;
      }

      get perView() {
        const width = this.slides[0].getBoundingClientRect().width;
        if (!width) return 1;
        return Math.max(1, Math.round((this.track.clientWidth + this.gap) / (width + this.gap)));
      }

      get pages() {
        return Math.max(1, this.slides.length - this.perView + 1);
      }

      offsetOf(i) {
        return this.slides[i].offsetLeft - this.slides[0].offsetLeft;
      }

      goTo(i, smooth = true) {
        const target = Math.min(Math.max(i, 0), this.pages - 1);
        this.track.scrollTo({
          left: this.offsetOf(target),
          behavior: smooth && !this.reduceMotion ? 'smooth' : 'auto',
        });
      }

      step(direction) {
        const last = this.pages - 1;
        let next = this.index + direction;
        if (next < 0) next = this.loop ? last : 0;
        if (next > last) next = this.loop ? 0 : last;
        this.goTo(next);
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.sync();
        });
      }

      onResize() {
        this.render();
      }

      onVisibility() {
        if (document.hidden) {
          this.pause();
        } else {
          this.play();
        }
      }

      onBlockSelect(event) {
        if (!this.contains(event.target)) return;
        this.pause();
        const slide = event.target.closest('[data-reviews-slide]');
        const i = this.slides.indexOf(slide);
        if (i > -1) this.goTo(i);
      }

      onBlockDeselect(event) {
        if (!this.contains(event.target)) return;
        this.play();
      }

      render() {
        this.buildDots();
        this.sync();
      }

      buildDots() {
        if (!this.dotsEl) return;
        const count = this.pages;
        if (count === this.dotCount) return;
        this.dotCount = count;
        this.dotsEl.innerHTML = '';
        for (let i = 0; i < count; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'review-slider__dot';
          dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
          dot.addEventListener('click', () => this.goTo(i));
          this.dotsEl.appendChild(dot);
        }
      }

      sync() {
        const x = this.track.scrollLeft;
        let best = 0;
        let bestDistance = Infinity;
        for (let i = 0; i < this.pages; i++) {
          const distance = Math.abs(this.offsetOf(i) - x);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        }
        this.index = best;
        this.updateUI();
      }

      updateUI() {
        if (this.dotsEl) {
          Array.from(this.dotsEl.children).forEach((dot, i) => {
            dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
          });
        }

        if (this.currentEl) this.currentEl.textContent = String(this.index + 1).padStart(2, '0');
        if (this.totalEl) this.totalEl.textContent = String(this.pages).padStart(2, '0');

        if (!this.loop) {
          if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
          if (this.nextBtn) this.nextBtn.disabled = this.index >= this.pages - 1;
        }
      }

      play() {
        if (this.dataset.autoplay !== 'true' || this.reduceMotion) return;
        if (this.pages < 2) return;
        this.pause();
        const interval = parseInt(this.dataset.autoplayInterval, 10) || 5000;
        this.timer = setInterval(() => {
          const next = this.index >= this.pages - 1 ? 0 : this.index + 1;
          this.goTo(next);
        }, interval);
      }

      pause() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    customElements.define('review-slider', ReviewSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
